/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_GdprInputs */

const en_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const de_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-Datenschutz`)
};

const fr_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données UE`)
};

const es_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad UE`)
};

const it_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy UE`)
};

const nl_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-privacy`)
};

const pl_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatnosc UE`)
};

const fi_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-yksityisyys`)
};

const da_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-privatliv`)
};

const sv_landing_trust_gdpr = /** @type {(inputs: Landing_Trust_GdprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-integritet`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Landing_Trust_GdprInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_gdpr = /** @type {((inputs?: Landing_Trust_GdprInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_GdprInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_gdpr(inputs)
	if (locale === "fr") return fr_landing_trust_gdpr(inputs)
	if (locale === "es") return es_landing_trust_gdpr(inputs)
	if (locale === "it") return it_landing_trust_gdpr(inputs)
	if (locale === "nl") return nl_landing_trust_gdpr(inputs)
	if (locale === "pl") return pl_landing_trust_gdpr(inputs)
	if (locale === "fi") return fi_landing_trust_gdpr(inputs)
	if (locale === "da") return da_landing_trust_gdpr(inputs)
	if (locale === "sv") return sv_landing_trust_gdpr(inputs)
	return en_landing_trust_gdpr(inputs)
});